import { backofficeRequest } from '../../../axios'

export const fetchTemplate = async (templateId) => {
  try {
    const response = await backofficeRequest.get(
      `backoffice/templates/${templateId}`
    )
    return response.data
  } catch (error) {
    return error
  }
}

export const createTemplate = async (formData) => {
  try {
    const response = await backofficeRequest.post(
      'backoffice/templates/create',
      JSON.stringify({ ...formData })
    )
    return response.data
  } catch (error) {
    return error
  }
}

export const editTemplate = async (formData, templateId) => {
  try {
    const response = await backofficeRequest.post(
      `backoffice/templates/update/${templateId}`,
      JSON.stringify({ ...formData })
    )
    return response.data
  } catch (error) {
    return error
  }
}
